var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcPersonalInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2415_3530)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.4029 0C9.61471 0.0410949 9.82915 0.0708887 10.0378 0.124312C12.1606 0.67036 13.528 1.98077 13.9669 4.06582C14.5934 7.03801 12.5033 9.5371 9.86718 10.0318C7.43911 10.4879 5.01633 9.23967 4.06402 7.01901C3.26065 5.14559 3.63671 2.89719 5.28571 1.3926C6.11548 0.635943 7.07784 0.163352 8.21396 0.0390401C8.24565 0.0354443 8.27523 0.0133558 8.30586 0C8.6719 0 9.0374 0 9.4029 0Z",
    fill: "#252525"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.00237 20.9966C7.19598 20.9966 5.38959 21.0064 3.58373 20.992C2.78828 20.9853 2.04724 20.7655 1.39863 20.299C0.604765 19.7278 0.133625 18.9568 0.0485871 18.0065C-0.106171 16.2774 0.0982364 14.5827 0.759523 12.9626C1.16094 11.9783 1.75938 11.1313 2.75553 10.6119C3.36928 10.2919 4.02793 10.1363 4.71721 10.1481C4.93482 10.1517 5.16511 10.2554 5.36371 10.3597C5.68379 10.5282 5.98221 10.7363 6.29067 10.9258C7.22344 11.4991 8.23333 11.8104 9.34411 11.7292C10.1617 11.6696 10.9176 11.404 11.6169 10.9895C11.8567 10.8472 12.1049 10.7126 12.322 10.5421C12.8924 10.0947 13.5231 10.0875 14.1965 10.2334C15.4388 10.502 16.3135 11.2201 16.9188 12.284C17.5209 13.3422 17.7972 14.4934 17.9144 15.682C17.9778 16.3267 18.0032 16.9775 17.9989 17.6253C17.9878 19.3765 16.6341 20.7932 14.8393 20.956C14.5605 20.9812 14.2789 20.9956 13.999 20.9961C12.3331 20.9997 10.6677 20.9982 9.00184 20.9982C9.00237 20.9982 9.00237 20.9976 9.00237 20.9966Z",
    fill: "#252525"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2415_3530"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPersonalInfo);
export default __webpack_public_path__ + "static/media/ic-personal-info.08f76e1b035fe4d69c45f32c6ffd3a7f.svg";
export { ForwardRef as ReactComponent };